<template>

    <!-- 主容器 -->
    <div class="yx-div">
        <div style="position: absolute; margin-top: -10px; z-index: 99;">
            <span style="font-size: 13px; font-weight: bold; color: orange ">{{this.$router.currentRoute.name}}</span>
        </div>

    <!-- 工具栏-->
        <div class="yx-div-top">
            <div class="yx-flex-h-between">
                <div  class="yx-flex-h-start2" style="margin-top: 5px;">
                    <div>
                        订单号：
                        <el-input placeholder="订单号" v-model="searchVal.payOrderNo" clearable size="mini" style="width: 130px; margin-right: 15px;" />

                    </div>
                    <div>
                        支付渠道：<el-select clearable v-model="searchVal.payWayCode" placeholder="支付渠道" size="mini" style="width: 120px;margin-right: 15px;">
                        <el-option class="f12"
                                   v-for="item in this._enums.PayWayEnum"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                    <div>
                        支付方式：<el-select clearable v-model="searchVal.payModeCode" placeholder="支付方式" size="mini" style="width: 120px;margin-right: 15px;">
                        <el-option class="f12"
                                   v-for="item in this._enums.PayModeEnum"
                                   :key="item.id"
                                   :label="item.name"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                    </div>
                    <!--
                    <div>
                        交易类型：
                        <el-select clearable v-model="searchVal.transType" placeholder="交易类型" size="mini" style="width: 150px;margin-right: 15px;">
                            <el-option class="f12"
                                       v-for="item in this._enums.TransTypeEnum"
                                       :key="item.id"
                                       :label="item.name"
                                       :value="item.id">
                            </el-option>
                        </el-select>
                    </div>
                    -->
                    <div>
                        交易日期：
                        <el-date-picker
                                v-model="searchVal.transDateScope"
                                value-format="yyyy-MM-dd"
                                type="daterange"
                                size="mini"
                                style="width:250px"
                                unlink-panels
                                range-separator="至"
                                start-placeholder="开始日期"
                                end-placeholder="结束日期">
                        </el-date-picker>
                    </div>
                    <el-tooltip content="清空查询条件"><i class="el-icon-circle-close cls-refresh" @click="searchReset"/></el-tooltip>
                </div>
                <div>
                    <!--
                    <el-button type="success" @click="exportData" icon="el-icon-download" plain>导出</el-button>
                    -->
                    <el-button type="primary" icon="el-icon-search" @click="searchDo">查询</el-button>
                </div>
            </div>
        </div>



        <!-- 数据栏 -->
        <div class="yx-div-center">
            <!-- 数据表 -->
            <el-table
                    :data="transs"
                    border
                    :header-cell-style="{background:'#fafafa'}"
                    v-loading="loading"
                    height="100%"
                    style="width: 100%;">
                <el-table-column prop="mchInfo.mchName" label="商户名称" align="center" width="200" show-overflow-tooltip />
                <el-table-column prop="mchNo" label="商户号" align="center" width="160" />
                <el-table-column prop="mchTerInfo.terNo" label="终端号" align="center" width="100" show-overflow-tooltip >
                    <!--
                    <template slot-scope="scope">
                        81923021
                    </template>
                    -->
                </el-table-column>
                <el-table-column prop="type" label="交易类型" align="center" width="80">
                    <template slot-scope="scope">
                        <div v-if="scope.row.type===1">
                            {{_enums.PayOrderTypeEnum.getNameById(scope.row.type)}}
                        </div>
                        <div v-else style="color: red; font-weight: bolder;">
                            <el-tag type="danger">
                                {{_enums.PayOrderTypeEnum.getNameById(scope.row.type)}}
                            </el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="payWayCode" label="支付渠道" align="center" width="80" >
                    <template slot-scope="scope">
                        {{_enums.PayWayEnum.getNameById(scope.row.payWayCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="payModeCode" label="支付方式" align="center" width="80" >
                    <template slot-scope="scope">
                        {{_enums.PayModeEnum.getNameById(scope.row.payModeCode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="buyerId" label="交易账号" align="left" width="150" show-overflow-tooltip />
                <el-table-column prop="amount" label="交易金额" align="right" width="100" :formatter="funFmtTransAmt" />
                <!--
                <el-table-column prop="amount" label="手续费" align="right" width="80" :formatter="funFmtTemp" />
                                            <span v-else>scope.row.orgPayOrderNo</span>

                <el-table-column prop="amount" label="实拨金额" align="right" width="100" :formatter="funFmtTransAmt" />
                -->
                <el-table-column prop="paySuccTime" label="交易日期" align="center" width="100" :formatter="funDateFormatter" />
                <el-table-column prop="paySuccTime" label="交易时间" align="center" width="80" :formatter="funTimeFormatter" />
                <el-table-column prop="payOrderNo" label="订单号" align="center" width="160" />
                <el-table-column prop="orgPayOrderNo" label="原订单号" align="center" width="160" />

                <el-table-column fixed="right" label="操作" align="center" >
                    <template slot-scope="scope">
                        <div class="yx-flex-h-center" >
                            <el-button v-if="scope.row.type===1"  type="text"  size="mini" @click="refund(scope.row)">退款</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>

        </div>

        <!-- 分页栏 -->
        <div class="yx-flex-h-end">
            <el-pagination
                    :current-page.sync="page"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    layout="sizes, prev,pager,next, jumper,->, total, slot"
                    :total="total">
            </el-pagination>
        </div>




        <el-dialog
                title="确定退款？"
                :visible.sync="dialogVisible"
                class="dlg-normal"
                width="40%">
            <div>
                <table style="margin: auto">
                    <tr>
                        <td>
                            <el-tag class="txt-tag">订单编号</el-tag>
                        </td>
                        <td>
                            <el-input disabled size="small" v-model="refundData.payOrderNo"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag class="txt-tag">订单金额</el-tag>
                        </td>
                        <td>
                            <el-input disabled size="small" v-model="refundData.sourceAmount"></el-input>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <el-tag class="txt-tag">退款金额</el-tag>
                        </td>
                        <td>
                            <el-input-number
                                    size="large"
                                    v-model="refundData.amount"
                                    :precision="2"
                                    placeholder="(单位:元)"
                                    :step="1"
                                    :min="0"
                                    :controls="false"
                            />
                            <!--
                            <el-input size="small" @input="formatAmount" v-model="refundData.amount"></el-input>
                            -->
                        </td>
                    </tr>
                </table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="dialogVisible = false">取 消</el-button>
                <el-button size="small" type="primary" @click="refundDo">确 定</el-button>
            </span>
        </el-dialog>
    </div>

</template>

<script>
    // name 组件名
    // data return 组件内的变量声明
    // created:html加载完成前 执行。执行顺序:父组件-子组件
    // mounted:html加载完成后 执行。执行顺序:子组件-父组件
    // methods:事件方法
    // watch:去监听一个值的变化，然后执行相对应的函数
    // computed:computed是属性调用，而methods是函数调用，computed带有缓存功能，而methods不是
    export default {
        name: "BillDetails",
        //组件中的data和实例中的不一样，实例中的data是一个对象，而组件中的data则是一个方法并且返回一个对象
        data() {
            //所有的变量都是写在data 的return里面
            //使用return包裹后数据中变量只在当前组件中生效,不会影响其他组件。
            return {
                dialogVisible: false,
                searchVal: {
                    payOrderNo : null,
                    payWayCode : null,
                    payModeCode : null,
                    transType : null,
                    transResult : null,
                    transDateScope : null
                },
                loading: false, // 加载提示 v-loading 变量
                total: 0,       // 总计 变量
                page: 1,        // 页数 变量
                size: 10,       // 每页大小 变量

                acqChannels :[],   // 交易渠道 集合
                transs: [],   // 交易对象 数组变量
                oneTransDetail: null,
                transJnlKey: {
                    sysDate:'',
                    sysTime:'',
                    sysSerial:''
                },
                refundData: {
                    mchNo: null,
                    payOrderNo: null,
                    sourceAmount: null,
                    amount: null
                }
            }
        },
        mounted() {
            this.initTransJnl();
        },
        methods: {
            refund (data) {
                this.refundData.mchNo = data.mchNo
                this.refundData.payOrderNo = data.payOrderNo
                this.refundData.sourceAmount = data.amount
                this.dialogVisible = true
            },
            refundDo () {
                if (!this.refundData.amount || this.refundData.amount<=0) {
                    this.$message.warning("请输入退款金额!");
                    return
                }

                this.loading = true;
                this.dialogVisible = false;
                this.putRequest("/mch/refundTrans", this.refundData).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.initTransJnl();
                    }
                })
            },
            formatAmount(value) {
                // 使用正则表达式来格式化金额输入
                this.amount = value.replace(/[^\d.]/g, '') // 清除非数字和点
                    .replace(/\.{2,}/g, '.') // 只保留第一个点
                    .replace('.', '$#$')
                    .replace(/\./g, '')
                    .replace('$#$', '.')
                    .replace(/\b(\d+)?(\.\d{2})\b/g, '$1$2') // 只保留两位小数
                    .replace(/^(\d*)$/, '$1.00') // 如果没有输入小数点，则在末尾添加".00"
            },
            searchReset() {
                this.searchVal = {};
            },
            searchDo() {
                this.page = 1;
                this.initTransJnl();
            },
            initTransJnl() {
                this.loading = true;
                let url = '/bill/details/?page=' + this.page + '&size=' + this.size;

                if (this.searchVal.payOrderNo) {
                    url += '&payOrderNo=' + this.searchVal.payOrderNo;
                }
                if (this.searchVal.payWayCode) {
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                }
                if (this.searchVal.payModeCode) {
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                }
                if (this.searchVal.transDateScope) {
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                }

                this.getRequest(url).then(resp => {
                    this.loading = false;
                    if (resp) {
                        this.transs = resp.data;
                        this.total = resp.total;
                        console.log("交易总笔数："+this.total);
                    }
                });
            },
            exportData() {

                let url = '/bill/details/export?page=1';
                if (this.searchVal.payOrderNo) {
                    url += '&payOrderNo=' + this.searchVal.payOrderNo;
                }
                if (this.searchVal.payWayCode) {
                    url += '&payWayCode=' + this.searchVal.payWayCode;
                }
                if (this.searchVal.payModeCode) {
                    url += '&payModeCode=' + this.searchVal.payModeCode;
                }
                if (this.searchVal.transDateScope) {
                    url += '&transDateScope=' + this.searchVal.transDateScope;
                }


                window.open(url, '_parent');
            },
            initTransAcqChannels() {
                this.getRequest('/bill/acqChannel').then(resp => {
                    if (resp) {
                        this.acqChannels = resp;
                        window.sessionStorage.setItem("acqChannels", JSON.stringify(resp));
                    }
                })
            },
            funFmtTransAmt(row, column) {
                return row.amount.toFixed(2);
            },
            funFmtTemp(row, column) {
                return '0.00';
            },
            // 日期格式化
            funDateFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(0,10);
                }
                return tm;
            },
            // 时间格式化
            funTimeFormatter (row, column) {
                let tm = row.paySuccTime;
                if(tm && tm.length===19) {
                    tm = tm.substring(11,19);
                }
                return tm;
            },
            sizeChange(currentSize) {
                this.size = currentSize;
                this.initTransJnl();
            },
            currentChange(currentPage) {
                this.page = currentPage;
                this.initTransJnl();
            },
        }
    }
</script>

<style>

    .pageNormal {
        font-size: 13px;
        font-family: 微软雅黑;
        box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04)
    }

    /* 可以设置不同的进入和离开动画 */
    /* 设置持续时间和动画函数 */
    .slide-fade-enter-active {
        transition: all .5s ease;
    }

    .slide-fade-leave-active {
        transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
    }

    .slide-fade-enter, .slide-fade-leave-to
        /* .slide-fade-leave-active for below version 2.1.8 */
    {
        transform: translateX(10px);
        opacity: 0;
    }

    .style-input-width {
        max-width: 120px;
    }

    .xtable{position:absolute;bottom:100px;}
    .xfooter{position:absolute;bottom:0;width:100%;height:100px;background-color: #ffc0cb;}

</style>
